function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// eslint-disable-next-line no-restricted-imports
import BaseLink from 'found/lib/Link';
import React from 'react';
import Anchor from './Anchor';

function Link(props) {
  return React.createElement(BaseLink, _extends({
    as: Anchor
  }, props));
}

export default Link;